
import { Vue, Component, Prop } from "vue-property-decorator";

interface Contact {
  emergency_contact_name: string;
  emergency_relationship: string;
  emergency_phone_number: string;
  emergency_secondary_contact: string;
  emergency_additional_notes: string;
}


@Component
export default class EmergencyContact extends Vue {
  @Prop({ required: true }) readonly data!: Contact;
}
